export const matchTaskStatusColors = (taskStatus) => {
    switch (String(taskStatus)) {
        case '1':
        case '11': // 退單驗證中（扣款狀態+10對稱）
            return 'warning';
        case '3':
        case '13': // 退單處理中
            return 'info';
        case '2':
        case '12': // 退單已驗證
            return 'success';
        case '4':
        case '14': // 退單完成
            return 'success-darken';
        case '7':
        case '17': // 退單驗證失敗
            return 'gray';
        case '8':
        case '9':
        case '18': // 退單處理失敗
        case '19': // 退單發生錯誤
            return 'error';
        default:
            return 'gray';
        // return 'warning';
    }
};

/**
 * @description 檢核扣款頁任務類型（對應後端 CyclePurchaseTaskTypeEnum）
 */
export const TASK_TYPE = {
    BILLING: 1,
    RETURN: 2,
};

/** 網址缺值或不合法時採用的任務類型 */
export const DEFAULT_TASK_TYPE = TASK_TYPE.BILLING;

/**
 * @description 扣款／退單分頁設定，分頁差異集中於此
 * - label：分頁標籤
 * - statusOptionKey：options API 對應該分頁的狀態下拉欄位
 * - actionLabel：分頁右上按鈕文字
 * - openUploadDialogKey：按鈕對應 CyclePurchaseDialogBox 的開窗函式名
 */
export const TASK_TYPE_CONFIGS = {
    [TASK_TYPE.BILLING]: {
        taskType: TASK_TYPE.BILLING,
        label: '扣款',
        statusOptionKey: 'billingTaskStatusOption',
        actionLabel: '匯入主檔',
        openUploadDialogKey: 'openUploadCyclePurchaseOrderSheetDialog',
    },
    [TASK_TYPE.RETURN]: {
        taskType: TASK_TYPE.RETURN,
        label: '退單',
        statusOptionKey: 'returnTaskStatusOption',
        actionLabel: '上傳退單總表',
        openUploadDialogKey: 'openUploadCyclePurchaseReturnOrderSheetDialog',
    },
};

/** PageLayout.Tabs 使用的分頁清單 */
export const TASK_TYPE_TABS = Object.values(TASK_TYPE_CONFIGS).map(({ label, taskType }) => ({ label, value: taskType }));

/**
 * @description 將網址的 taskType 轉為合法任務類型，缺值或不合法時視為扣款
 * @param {string|number} value - 網址上的 taskType
 * @returns {number} - 任務類型（1 扣款、2 退單）
 */
export const parseTaskType = (value) => {
    const taskType = Number(value);
    return TASK_TYPE_CONFIGS[taskType] ? taskType : DEFAULT_TASK_TYPE;
};

/**
 * @description 匹配訂單狀態顏色
 * @param {number} orderStatus - 訂單狀態
 * @returns {string} - 訂單狀態顏色
 */ 

export const matchOrderStatusColors = (orderStatus) => {
    switch (String(orderStatus)) {
        case '1':
            return 'success';
        case '2':
            return 'warning';
        case '3':
            return 'gray';  
        default:
            return 'warning';

    }
};

/**
 * @description 匹配訂單付款狀態顏色
 * @param {number} orderPaymentStatus - 訂單付款狀態
 * @returns {string} - 訂單付款狀態顏色
 * 付款狀態 
 1 付款成功或免付款, 2 付款中, 3 未付款, 8 付款欠費, 9 付款異常
 */ 

export const matchOrderPaymentStatusColors = (orderPaymentStatus) => {
    switch (String(orderPaymentStatus)) {
    case '1': // 付款成功或免付款
        return 'success'; 
    case '2': // 付款中
        return 'info';
    case '3': // 未付款
        return 'grey'; 
    case '8': // 付款欠費
        return 'warning'; 
    case '9': // 付款異常
        return 'error'; 
    default:
        return 'grey';
    }
};